export const Entry = ({ label, value, mb = true }) => (
	<div className={`col-12 col-sm-6 col-lg-4 ${mb && "mb-4"}`}>
		<dt className="col-12 text-primary">{label}</dt>
		<dd className="col-12 text-white">{value}</dd>
	</div>
);

export const BooleanDisplayMessage = ({ check }) =>
	check ? (
		<span className="text-success">Yes</span>
	) : (
		<span className="text-danger">No</span>
	);

export const BorderedBox = ({ children, className }) => (
	<div
		className={`row mx-0 py-3 px-2 mb-4 ${className}`}
		style={{
			border: "2px solid #ffffff25",
			borderRadius: 8,
		}}
	>
		{children}
	</div>
);

export const BorderedBoxEntry = ({
	label,
	value,
	fullWidth = false,
	marginClass,
	color = "primary",
	sameLine = false,
}) => (
	<div
		className={`${fullWidth ? "col-sm-12" : "col-sm-6"} ${marginClass} ${
			sameLine && " d-flex "
		}`}
	>
		<dt className={`text-${color} ${sameLine && " mr-5"}`}>
			{label}
			{sameLine && " :"}
		</dt>
		<dd className="text-white">{value}</dd>
	</div>
);
